import React from 'react';
import { AppBar, Toolbar, Box, IconButton, Divider, Tooltip } from '@mui/material';
import { LogoBanner } from '../../icons';
import { useAuth } from '../../contexts/AuthContext';
import { Organization } from '../../types/organization';
import ProfileDropdown from './ProfileDropdown';
import ChangeOrganization from './ChangeOrganization';
import { Link } from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';
// import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined'; // hidden until notifications are implemented
import NavigationDropdown from './NavigationDropdown';

export interface BannerProps {
  selectedOrg: Organization | null;
  setSelectedOrg: React.Dispatch<React.SetStateAction<Organization | null>>;
  handleOrgSelect: (org: Organization) => void;
  handleClose: () => void;
  anchorEl?: HTMLElement | null;
  avatarEl?: HTMLElement | null;
  setAnchorEl?: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  setAvatarEl?: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}

const Banner: React.FC = () => {
  const { user, setActivePage } = useAuth();

  return (
    user && (
      <AppBar className='header'>
        <Toolbar
          disableGutters
          sx={{
            width: '100%',
            py: 1,
            px: { xs: 1.5, sm: 2 }, // horizontal padding so the logo never touches the edge
          }}
        >
          <Box
            sx={{
              // py: 1,
              // px: { xs: 1.5, sm: 2 },
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {/* Left side: Logo */}
            <Box
              onClick={() => setActivePage('dashboard')}
              sx={{
                textDecoration: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <img
                src={LogoBanner}
                alt='MarketSmart'
                style={{
                  // paddingTop: '6px',
                  height: 24,
                  width: 148,
                  display: 'block',
                  alignSelf: 'center',
                }}
              />
            </Box>
            {/* Right side: actions + org chip + profile */}
            <Box
              sx={{
                ml: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1, sm: 1.5 },
                flexShrink: 0, // don't let this group collapse off-screen
                whiteSpace: 'nowrap', // keep chip/profile on one line
              }}
            >
              <ChangeOrganization />
              <NavigationDropdown />
              <Divider 
                orientation='vertical' 
                sx={{
                  height: '24px',
                  backgroundColor: theme =>
                    theme.palette.divider,
                }}
              />

              <Box
                sx={{
                  display: 'flex',
                }}
              >
                <Box
                  data-testid='service-request'
                  sx={{ display: { xs: 'none', sm: 'flex' } }}
                >
                  <Tooltip title={'Service request'}>
                    <Link
                      href="https://imarketsmart.atlassian.net/servicedesk/customer/portals"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        height: 'fit-content',
                        alignSelf: 'center',
                      }}
                    >
                      <IconButton>
                        <ComputerIcon />
                      </IconButton>
                    </Link>
                  </Tooltip>
                </Box>

                {/* Notifications bell — no functionality yet; restore when implemented
                <Tooltip title={'Notifications'}>
                  <IconButton
                    sx={{
                      height: 'fit-content',
                      alignSelf: 'center',
                    }}
                  >
                    <NotificationsOutlinedIcon />
                  </IconButton>
                </Tooltip>
                */}
                
                <ProfileDropdown />
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    )
  );
};

export default Banner;
